module.exports = __webpack_public_path__ + "img/templates.2a5b37ca.png";